import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Typography,
  createFilterOptions,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import CloseIcon from "@mui/icons-material/Close";
import debounce from "lodash/debounce";
import axios from "axios";
import { getUserWallet } from "redux/actions/usersActions";
import { calculateFeeRequestAction } from "redux/actions/GeneralActions";
import { useDispatch, useSelector } from "react-redux";
import Autocomplete from "components/Autocomplete";
import DropDown from "components/DropDown";
import AppNumberInput from "components/AppNumberInput";
import { toFixedWithoutZeros } from "constants/usefulFunctions";
import { API_GET_SEARCH } from "constants/constants";
import { topupCardRequestAction } from "redux/actions/cardActions";
import { showMessage } from "components/Modal";
import { TOP_UP_CARD_STARTED } from "redux/ActionTypes";
import { getWalletBalancesRequestAction } from "redux/actions/walletActions";

const TopUpUser = () => {
  const dispatch = useDispatch();

  const authToken = useSelector((state) => state.auth.token);
  const rType = useSelector((state) => state.card.rType);
  const { walletBalances } = useSelector((state) => ({
    walletBalances: state.wallet.walletBalances,
  }));

  const [amount, setAmount] = useState("0.0");
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [value, setValue] = useState({});
  const [inputValue, setInputValue] = useState("");
  const [userWallets, setUserWallets] = useState([]);
  const [wallet, setWallet] = useState("");
  const [userLimits, setUserLimits] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [minBalance, setMinBalance] = useState(0.0);
  const [balanceChanged, setBalanceChanged] = useState(false);
  const [errors, setErrors] = useState({});
  const [showFeeDetails, setShowFeeDetails] = useState(false);

  const selectedBalance = walletBalances.find((b) => b.currency_id === wallet);

  const topUpFee = (
    parseFloat(userLimits?.userFee) +
    (parseFloat(userLimits?.userPercentFee) / 100) * amount
  ).toFixed(2);

  useEffect(() => {
    if (inputValue.length > 3) request();
  }, [inputValue]);

  useEffect(() => {
    if ("id" in value && wallet)
      dispatch(
        calculateFeeRequestAction({
          eventId: 17,
          userId: value.id,
          currencyId: wallet,
          setUserLimits,
        })
      );
    dispatch(getWalletBalancesRequestAction());
  }, [value, wallet]);

  useEffect(() => {
    if (userWallets?.length > 0) {
      const userWallet = userWallets.find((item) => item.id === wallet);
      if (userWallet) {
        setShowFeeDetails(true);
        setMinBalance(userWallet.minimumBalance);
      }
    }
  }, [userWallets, wallet]);

  console.log(userLimits, 999);
  const handleChange = debounce((newValue) => {
    setInputValue(newValue);
  }, 400);

  const request = () => {
    if (!loading) setLoading(true);
    axios
      .post(
        API_GET_SEARCH,
        { keyword: inputValue },
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      )
      .then((res) => {
        setLoading(false);
        setOptions(res.data.data);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching data:", error);
      });
  };

  const filterOptions = createFilterOptions({
    stringify: (option) =>
      `${option.firstName} ${option.lastName}` +
      option.email +
      option.mobile?.toString() +
      option.iban?.toString() +
      option.website_domain +
      option?.channel_name,
  });

  const handleSubmit = () => {
    dispatch(
      topupCardRequestAction({
        amount,
        email: value.email,
        currencyId: wallet,
        onSuccess: () => {
          setShowConfirm(false);
          setShowFeeDetails(false);
          setValue({});
          setUserWallets();
          setAmount(0.0);
          showMessage({
            status: "success",
          });
        },
      })
    );
  };

  const handleClose = () => {
    setShowConfirm(false);
  };

  const handleAmountChange = (e) => {
    setAmount(e.target.value);
    setBalanceChanged(true);
  };

  const renderDialogConfirm = (
    <Dialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={showConfirm}
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        Top-up Card
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <Typography gutterBottom>
          User: {value.firstName} {value.lastName}
        </Typography>
        <Typography gutterBottom>Email: {value.email}</Typography>
        <Typography gutterBottom>
          Amount: {toFixedWithoutZeros(amount)}
          {userLimits?.symbol}
        </Typography>
        {/* <Typography gutterBottom>
          Fee: {toFixedWithoutZeros(topUpFee)}
          {userLimits.symbol}
        </Typography> */}
      </DialogContent>
      <DialogActions>
        <Button color="error" onClick={handleClose}>
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          onClick={handleSubmit}
          loading={rType === TOP_UP_CARD_STARTED}
        >
          Submit
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );

  return (
    <Card style={{ paddingBottom: "20px", borderRadius: 0 }}>
      <CardHeader title="Top up Card" />
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4} xl={3}>
            <div
              className={`searchbox right-side-icon bg-transparent d-block`}
              // style={{ width: "320px", maxWidth: "420px" }}
            >
              <Autocomplete
                id="combo-box-demo"
                fullWidth
                options={options}
                getOptionLabel={(option) => (option.email ? option.email : "")}
                loading={loading}
                filterOptions={filterOptions}
                renderOption={(e, option) => {
                  return (
                    <div
                      key={option.id}
                      onClick={(v) => {
                        setValue(option);
                        dispatch(
                          getUserWallet({
                            email: option.email,
                            setData: setUserWallets,
                          })
                        );
                      }}
                      {...e}
                      className={`${e.className} option-container`}
                    >
                      <div>
                        <span>Name: </span>
                        {String(option.firstName) +
                          " " +
                          String(option.lastName)}
                      </div>
                      {/* <div>
                    <span>Mobile:</span> {String(option.mobile)}
                  </div> */}
                      <div>
                        <span>Email:</span> {String(option.email)}
                      </div>
                    </div>
                  );
                }}
                onInputChange={(_, newValue) => {
                  handleChange(newValue);
                }}
                onChange={(_, newValue) => {
                  setValue(newValue);
                  dispatch(
                    getUserWallet({
                      email: newValue.email,
                      setData: setUserWallets,
                    })
                  );
                  setLoading(false);
                }}
                value={value}
                disablePortal
                clearOnEscape
                autoHighlight
                blurOnSelect
                selectOnFocus
                handleHomeEndKeys
                onBlur={() => {
                  setInputValue("");
                  setLoading(false);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="User"
                    variant="outlined"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <div
                          style={{
                            backgroundColor: "white",
                            height: 36,
                            alignItems: "center",
                            display: "flex",
                          }}
                        >
                          {loading && (
                            <CircularProgress color="primary" size={30} />
                          )}

                          {params.InputProps.endAdornment}
                        </div>
                      ),
                    }}
                  />
                )}
              />
            </div>
          </Grid>
          <Grid item xs={12} md={3} xl={2}>
            <DropDown
              label="Currency"
              schema={{ label: "currency", value: "currency_id" }}
              items={userWallets}
              value={wallet}
              onChange={(event) => setWallet(event.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={3} xl={2}>
            <AppNumberInput
              thousandSeparator={true}
              label="Amount"
              onChange={handleAmountChange}
              value={amount}
              fullWidth
              decimalScale={2}
              error={errors.amount}
              helperText={errors.amount}
              maxLength={19}
              sx={{ boxSizing: "border-box" }}
            />
          </Grid>
          <Grid container item>
            <Grid
              xs={12}
              sx={{ visibility: userLimits ? "visible" : "hidden" }}
              item
            >
              <Typography sx={{ display: "inline" }}>Balance: </Typography>
              <Typography sx={{ display: "inline", fontWeight: 600 }}>
                {selectedBalance?.balance} {userLimits.symbol}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{ visibility: userLimits ? "visible" : "hidden" }}
            >
              <Typography sx={{ display: "inline" }}>
                Minimum Amount:{" "}
              </Typography>
              <Typography sx={{ display: "inline", fontWeight: 600 }}>
                {toFixedWithoutZeros(userLimits.min)} {userLimits.symbol}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{ visibility: userLimits ? "visible" : "hidden" }}
            >
              <Typography sx={{ display: "inline" }}>
                Maximum Amount:{" "}
              </Typography>
              <Typography sx={{ display: "inline", fontWeight: 600 }}>
                {userLimits.max} {userLimits.symbol}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
      <CardActions sx={{ justifyContent: "center" }}>
        <LoadingButton
          variant="contained"
          onClick={() => setShowConfirm(true)}
          disabled={
            !wallet || amount > +userLimits.max || amount < +userLimits.min
          }
        >
          Submit
        </LoadingButton>
      </CardActions>
      {renderDialogConfirm}
    </Card>
  );
};

export default TopUpUser;
